// extracted by mini-css-extract-plugin
export var arrowWrapper = "fg_f0";